import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { MainNavButton } from '../nav-button';

const COPY = defineMessages({
  HOME: {
    id: 'Home.home',
    defaultMessage: 'Home',
    description: '[Type: Label][Vis.: low] - Home button of nav bar',
  },
});

const Home = () => (
  <MainNavButton href="/home/" label={t(COPY.HOME)} />
);

export default Home;
export { Home };
